module.exports = __webpack_public_path__ + "img/sb_march83_p1.4db1026c.jpg";